export const ADMIN_ROLES = ["technical_admin", "admin", "staff"];

export const routePermissions = {
  dashboard: ["technical_admin", "admin", "staff"],
  users: ["technical_admin", "admin", "staff"],
  vehicles: ["technical_admin", "admin", "staff"],
  bookings: ["technical_admin", "admin", "staff"],
  drivers: ["technical_admin", "admin", "staff"],
  gpsTracking: ["technical_admin", "admin", "staff"],
  analyticsReports: ["technical_admin", "admin", "staff"],
  marketingCampaigns: ["technical_admin", "admin", "staff"],
  settings: ["technical_admin", "admin"],
  auditTrails: ["technical_admin", "admin"],
  changePassword: ["technical_admin", "admin", "staff"],
};

export const sidebarItems = [
  { key: "dashboard", to: "/dashboard", label: "Dashboard", icon: "dashboard" },
  { key: "bookings", to: "/bookings", label: "Booking Management", icon: "bookings" },
  { key: "vehicles", to: "/vehicles", label: "Vehicle Management", icon: "vehicles" },
  {
    key: "users",
    to: "/users",
    label: "Rental Management",
    technicalAdminLabel: "Rental Management",
    icon: "users",
  },
  { key: "gpsTracking", to: "/gps-tracking", label: "Live Monitoring", icon: "gps" },
  { key: "analyticsReports", to: "/analytics-reports", label: "Analytics & Reports", icon: "analytics" },
  { key: "marketingCampaigns", to: "/marketing-campaigns", label: "Marketing Campaigns", icon: "marketing" },
  { key: "drivers", to: "/drivers", label: "Driver Management", icon: "drivers" },
  { key: "settings", to: "/settings", label: "Settings", icon: "settings" },
  { key: "auditTrails", to: "/audit-trails", label: "Audit Trails", icon: "audit" },
];

export const normalizeRole = (role) => {
  const normalized = String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

  if (normalized === "technicaladmin") return "technical_admin";
  return normalized;
};

export const canAccessRoute = (role, routeKey) =>
  routePermissions[routeKey]?.includes(normalizeRole(role)) || false;

export const canSeeSidebarItem = canAccessRoute;

export const isAdminPortalRole = (role) =>
  ADMIN_ROLES.includes(normalizeRole(role));
